import type { Purchase } from "@tellescope/types-client";
import { getCurrencySymbol, formatDate } from "@tellescope/utils";
import { DashboardCard } from "../../dashboard-card";

// TODO: fix type upstream. processedAt is not a Date, but is a string...
type FixedPurchase = Omit<Purchase, "processedAt"> & { processedAt?: string | Date };

const purchaseIsInPast = (purchase: FixedPurchase): boolean => {
  if (!purchase.processedAt) return false;
  return new Date(purchase.processedAt).getTime() < Date.now();
};

interface PaymentContentProps {
  purchases: FixedPurchase[];
}

export function PaymentContent({ purchases }: PaymentContentProps) {
  return (
    <div className="flex-1 overflow-y-auto space-y-4 pr-2">
      {purchases.map((purchase) => (
        <DashboardCard
          key={purchase.id}
          title={purchase.title}
          eventDate={purchase.processedAt || undefined}
          dueDate={purchase.processedAt ? formatDate(purchase.processedAt) : ""}
          timestamp={purchase.processedAt || undefined}
          status={purchaseIsInPast(purchase) ? "default" : "outline"}
          statusLabel={purchaseIsInPast(purchase) ? "Complete" : "Incomplete"}
          assignees={[]}
          showUnreadDot={false}
          subtitle={`${getCurrencySymbol(purchase.cost.currency)}${purchase.cost.amount.toFixed(2)}`}
          subtitleSecondary={purchase.description}
          priority=""
        />
      ))}
    </div>
  );
}
